import { render } from "./UzhnetBackButton.vue?vue&type=template&id=52798c78"
import script from "./UzhnetBackButton.vue?vue&type=script&lang=js"
export * from "./UzhnetBackButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__